const config = {
  // 布尔类型值
  BooleanType: [
    { text: '是', value: true },
    { text: '否', value: false }
  ],
  // 性别
  Sex: [
    { text: '男', value: 1 },
    { text: '女', value: 2 }
  ],
  // 状态
  State: [
    { text: '可用', value: true },
    { text: '禁用', value: false }
  ],
  // 显示状态
  Hidden: [
    { text: '隐藏', value: true },
    { text: '可见', value: false }
  ],
  // 对齐方式
  Align: [
    { text: '左侧', value: 'left' },
    { text: '居中', value: 'center' },
    { text: '右侧', value: 'right' }
  ],
  // 班级状态
  ClassState: [
    { text: '启用', value: 'enable' },
    { text: '停用', value: 'stop' }
  ],
  // 数据范围
  DataRange: [
    { text: '全部', value: '1' },
    { text: '仅本人', value: '2' },
    { text: '本单位', value: '3' },
    { text: '自定义', value: '10' }
  ],
  // 实训计划状态
  PlanState: [
    { text: '启用', value: '1' },
    { text: '暂停', value: '2' },
    { text: '结束', value: '3' },
    { text: '未启用', value: '4' }
  ],
  // 课程平台
  CoursePlatform: [
    { text: '亚马逊', value: '1' },
    { text: '速卖通', value: '2' },
    // { text: 'eBay', value: '3' },
    { text: '选品', value: '3' },
    { text: 'GoogleAds', value: '4' },
    { text: 'Facebook', value: '5' },
    { text: 'TikTok', value: '6' }
  ],
  // 课程类型
  CourseType: [
    { text: '实习指导书', value: '1' },
    { text: '操作视频', value: '2' },
    { text: '教学课件', value: '3' },
    { text: '学习视频', value: '4' }
  ],
  // 课程层次
  CourseLevel: [
    { text: '零基础', value: '1' },
    { text: '初阶', value: '2' },
    { text: '进阶', value: '3' },
    { text: '高阶', value: '4' }
  ],
  // 考试成绩状态
  AchievementState: [
    { text: '待考试', value: '2' },
    { text: '考试中', value: '1' },
    { text: '已考完', value: '3' }
  ]
}

export default config
